import React from "react";
import Box from "@mui/material/Box";
import careStartLogo from "../../../assets/images/logos/carestart-patient-logo.png";

const CareStartDashboardLogo = ({ height, maxWidth, sx }) => (
  <Box
    component="img"
    src={careStartLogo}
    alt="CareStart — start the care process in your own language"
    sx={{
      display: "block",
      height: height ?? "auto",
      width: "auto",
      maxWidth: maxWidth ?? "100%",
      ...sx,
    }}
  />
);

export default CareStartDashboardLogo;
